var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "day" },
    [
      _vm._l(_vm.events, function(e) {
        return _c("div", { key: e.id, staticClass: "event" }, [
          _c(
            "div",
            { staticClass: "time" },
            [
              _c("input-time", {
                attrs: {
                  noLabel: "",
                  inputName: "eventTime",
                  inputValue: e.time,
                  sideValue: { id: e.id }
                },
                on: { fieldUpdate: _vm.setTime }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "delete",
              on: {
                click: function($event) {
                  return _vm.removeEvent(e.id)
                }
              }
            },
            [_c("icon", { attrs: { name: "times" } })],
            1
          )
        ])
      }),
      _vm._v(" "),
      _vm.canAddEvent
        ? _c(
            "div",
            {
              staticClass: "add-event",
              on: {
                click: function($event) {
                  return _vm.addEvent()
                }
              }
            },
            [
              _c(
                "button",
                { class: { disabled: !_vm.canAddEvent, add: true } },
                [_c("icon", { attrs: { name: "plus" } })],
                1
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab2bea94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab2bea94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/channelSelectionParts/EventDay.vue
// module id = null
// module chunks = 